import React, { useEffect } from "react";

/**
 * Lightweight per-page SEO / meta helper.
 * Sets document.title and updates <meta name="description">, canonical, and og tags.
 */
export const PageMeta = ({ title, description, canonical, image, ldJson }) => {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (name, content, attr = "name") => {
            if (!content) return;
            let el = document.head.querySelector(`meta[${attr}="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        setMeta("description", description);
        setMeta("og:title", title, "property");
        setMeta("og:description", description, "property");
        if (image) setMeta("og:image", image, "property");

        if (canonical) {
            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        }

        // Structured data
        let script = document.head.querySelector("#ld-json-page");
        if (script) script.remove();
        if (ldJson) {
            const s = document.createElement("script");
            s.type = "application/ld+json";
            s.id = "ld-json-page";
            s.text = JSON.stringify(ldJson);
            document.head.appendChild(s);
        }
    }, [title, description, canonical, image, ldJson]);

    return null;
};
